import { useState } from "react";
import { Radio, UserCheck, ShieldAlert, BadgeCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { VerifiedBadge } from "@/components/Brand";
import { RoomsManager } from "@/components/dashboard/RoomsManager";
import { RequestsPanel } from "@/components/dashboard/RequestsPanel";
import { AlertsPanel } from "@/components/dashboard/AlertsPanel";
import { VerificationPanel } from "@/components/dashboard/VerificationPanel";

export default function Dashboard() {
  const { user } = useAuth();
  const verified = user.role === "admin" || user.verified;
  const [tab, setTab] = useState(verified ? "rooms" : "seal");
  const [counts, setCounts] = useState({});
  const tabs = [
    { k: "rooms", l: "Minhas Salas", icon: Radio },
    { k: "requests", l: "Pedidos de Vínculo", icon: UserCheck, n: counts.requests },
    { k: "alerts", l: "Alertas IA", icon: ShieldAlert, n: counts.alerts },
    ...(user.role === "institution" ? [{ k: "seal", l: "Selo de Validação", icon: BadgeCheck }] : []),
  ];
  const setCount = (k) => (n) => setCounts((c) => ({ ...c, [k]: n }));

  return (
    <div className="py-6 md:py-10">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[hsl(var(--gold))]">Painel da Instituição</p>
      <h1 className="mt-2 flex items-center gap-2 text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="dashboard-title">
        {user.name} {user.verified && <VerifiedBadge size={26} />}
      </h1>
      {user.leader_name && <p className="mt-1 text-sm text-muted-foreground">Liderança: {user.leader_name}</p>}
      <div className="no-scrollbar mt-8 flex gap-2 overflow-x-auto border-b border-white/5 pb-3">
        {tabs.map((t) => (
          <button key={t.k} onClick={() => setTab(t.k)} data-testid={`dashboard-tab-${t.k}`}
            className={`shrink-0 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold transition-colors ${tab === t.k ? "bg-white text-black" : "text-muted-foreground hover:text-white"}`}>
            <t.icon size={15} /> {t.l}
            {t.n > 0 && <span className="rounded-full bg-amber-500 px-1.5 text-[10px] text-black">{t.n}</span>}
          </button>
        ))}
      </div>
      <div className="mt-6">
        {tab === "rooms" && <RoomsManager canCreate={user.role === "admin" || (user.role === "institution" && user.verified)} />}
        {tab === "requests" && <RequestsPanel onCount={setCount("requests")} />}
        {tab === "alerts" && <AlertsPanel onCount={setCount("alerts")} />}
        {tab === "seal" && <VerificationPanel />}
      </div>
    </div>
  );
}
